<div class="card">
  <div class="card-header" style="border-bottom: none">
    <div
      class="card-title d-flex justify-content-between align-items-center w-100"
    >
      <h4 style="margin: 0">{{ dynamicTitle || data.title }}</h4>

      <!-- Filter group -->
      <div class="filter-group d-flex align-items-center" style="gap: 16px">
        <label><strong>Spend Filter:</strong></label>

        <label>
          <input
            type="radio"
            name="spendFilter"
            value="all"
            [(ngModel)]="selectedFilter"
            (change)="applyFilter('all')"
          />
          All
        </label>

        <label>
          <input
            type="radio"
            name="spendFilter"
            value="lt50"
            [(ngModel)]="selectedFilter"
            (change)="applyFilter('lt50')"
          />
          &lt; $50k
        </label>

        <label>
          <input
            type="radio"
            name="spendFilter"
            value="gt50"
            [(ngModel)]="selectedFilter"
            (change)="applyFilter('gt50')"
          />
          &gt; $50k
        </label>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="note def">
      <strong>Definition:</strong>
      <ul style="margin: 4px 0 0 40px; padding: 0">
        <li>
          Spend Effectiveness (SE) is a metric which measures relative movement
          of PHI bubble for same amount of spend done for a specific
          segment-platform for eg. If the SE of Q60 is higher than Q19, it means
          Q60 bubble moved more than the Q19 bubble per $ million spent.
        </li>
        <li>
          Spend Effectiveness ∝ [movement of PHI bubble across x- or y-axis] /
          [spend done on that product]
        </li>
      </ul>
    </div>
    <div
      [id]="data.widgetId"
      [style.height]="data.height || '70vh'"
      [hidden]="hasError"
    ></div>
    <app-data-error *ngIf="hasError" [message]="errorMessage"></app-data-error>
    <div class="note">
      <strong>Notes:</strong>
      <ul style="margin: 4px 0 0 16px; padding: 0">
        <li>
          Negative values of Spend Effectiveness indicates PHI bubble movement
          in negative direction (left on x-axis and down of y-axis) even though
          after spending. These movements may potentially be due to external
          factors and not influenced by spends alone.
        </li>
      </ul>
    </div>
  </div>
</div>
